import { css } from '@emotion/css';

import { mobileMediaQuery, nonMobileMediaQuery } from '../../constants';
import { h2Css, m, p1Css } from '../../motif';

export const cardStackBlockCss = css`
  background-color: ${m('--bg-color')};
`;

export const cardStackBlockFullHeightCss = css`
  min-height: 100vh;
`;

export const boundaryCss = css`
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-xxl')};
  padding: ${m('--spacing-xxxxl')} ${m('--spacing-m')};

  ${nonMobileMediaQuery} {
    gap: 56px;
    padding: 98px ${m('--spacing-xxxxl')};
  }
`;

export const headerCss = css`
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-m')};
  padding: ${m('--spacing-m')};

  ${nonMobileMediaQuery} {
    gap: 0;
    padding: ${m('--spacing-m')} ${m('--spacing-xl')};
  }
`;

export const eyebrowCss = css`
  color: ${m('--fg-color')};
  font-size: ${m('--annotation-mobile-font-size')};
  font-weight: ${m('--annotation-mobile-font-weight')};
  letter-spacing: ${m('--annotation-mobile-font-letter-spacing')};
  line-height: ${m('--annotation-mobile-font-line-height')};

  ${nonMobileMediaQuery} {
    font-size: ${m('--annotation-desktop-font-size')};
    font-weight: ${m('--annotation-desktop-font-weight')};
    letter-spacing: ${m('--annotation-desktop-font-letter-spacing')};
    line-height: ${m('--annotation-desktop-font-line-height')};
  }
`;

export const titleCss = css`
  ${h2Css}
  color: ${m('--fg-color')};

  ${nonMobileMediaQuery} {
    margin-block: ${m('--spacing-xs')} 0;
  }
`;

export const textCss = css`
  ${p1Css}
  color: ${m('--fg-color')};

  ${nonMobileMediaQuery} {
    margin-block-start: ${m('--spacing-m')};
  }
`;

export const textAlignStartCss = css`
  ${nonMobileMediaQuery} {
    text-align: start;
  }
`;

export const textAlignCenterCss = css`
  ${nonMobileMediaQuery} {
    text-align: center;
  }
`;

export const textAlignEndCss = css`
  ${nonMobileMediaQuery} {
    text-align: end;
  }
`;

export const textAlignStartMobileCss = css`
  ${mobileMediaQuery} {
    text-align: start;
  }
`;

export const textAlignCenterMobileCss = css`
  ${mobileMediaQuery} {
    text-align: center;
  }
`;

export const textAlignEndMobileCss = css`
  ${mobileMediaQuery} {
    text-align: end;
  }
`;

export const cardsContainerCss = css`
  display: flex;
  flex-direction: column;
  gap: ${m('--spacing-m')};
  list-style: none;
  position: relative;

  ${mobileMediaQuery} {
    align-items: center;
  }

  ${nonMobileMediaQuery} {
    flex-direction: row;
    gap: ${m('--spacing-m')};

    > * {
      flex: 1;
      min-width: 0;
    }
  }
`;

export const stickyCardsContainerCss = css`
  ${mobileMediaQuery} {
    gap: 0;
  }
`;

export const cardsContainer2CardsCss = css`
  ${nonMobileMediaQuery} {
    justify-content: center;
    > * {
      flex: 0 1 432px;
      max-width: 432px;
    }
  }
`;

export const mobileStackItemCss = css`
  ${mobileMediaQuery} {
    max-width: 500px;
    width: 100%;
  }
`;

export const mobileStickyStackItemCss = css`
  ${mobileMediaQuery} {
    position: sticky;
    top: var(--total-header-height);
  }
`;
